import { Link } from 'react-router-dom';
import { X } from "lucide-react";
export default function Footer() {
  return <footer style={{
    backgroundColor: "oklch(0.129 0.042 264.695)",
    color: "oklch(0.704 0.04 256.788)",
    fontFamily: '"DM Sans", sans-serif'
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600;700&family=Outfit:wght@600;700&display=swap');
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(24px); }
          100% { opacity: 1; transform: translateY(0px); }
        }
        .footer-link {
          color: oklch(0.704 0.04 256.788);
          font-family: "DM Sans", sans-serif;
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          text-decoration: none;
          transition: color 0.15s ease;
          display: block;
        }
        .footer-link:hover {
          color: #ffffff;
        }
        .social-btn {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background-color: #1e2d40;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          transition: background-color 0.2s ease;
          cursor: pointer;
          flex-shrink: 0;
        }
        .social-btn:hover {
          background-color: #2563eb;
        }
        .cta-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background-image: linear-gradient(to right, #2563eb, #06b6d4);
          color: #ffffff;
          font-family: "DM Sans", sans-serif;
          font-size: 15px;
          font-weight: 600;
          border-radius: 9999px;
          padding: 14px 28px;
          border: none;
          cursor: pointer;
          box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.3), 0 4px 6px -4px rgba(37, 99, 235, 0.3);
          transition: opacity 0.2s ease, transform 0.2s ease;
          white-space: nowrap;
          text-decoration: none;
        }
        .cta-btn:hover {
          opacity: 0.9;
          transform: scale(1.03);
        }
      `}</style>

      <div className="page-container">
        <div style={{
        paddingTop: "80px",
        paddingBottom: "64px"
      }}>
          <div className="flex flex-col md:flex-row gap-12 md:gap-0">
            <div style={{
            minWidth: "300px",
            maxWidth: "380px",
            marginRight: "80px"
          }} className="flex-shrink-0">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1710017/img/6033f720-fa09-40cb-b4b8-5719b3bb6019_d04c9f008d.jpg" alt="CSN Digital" className="h-auto" style={{
              width: "120px",
              height: "32px",
              objectFit: "contain"
            }} src="https://hardy-tortoise-1.10web.cloud/wp-content/uploads/2026/06/CSN_Logo_2026-small-white-digital.png" />
              <p style={{
              color: "oklch(0.704 0.04 256.788)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "22.75px",
              marginTop: "24px",
              marginBottom: "0"
            }}>
                We help local businesses grow with custom web design, local SEO, and digital marketing strategies that generate real leads and revenue.
              </p>
              <div style={{
              marginTop: "24px",
              display: "flex",
              flexDirection: "column",
              gap: "12px"
            }}>
                <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                  <span style={{
                  color: "oklch(0.704 0.04 256.788)",
                  flexShrink: 0,
                  width: "16px",
                  height: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
                  </span>
                  <span style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400"
                }}>(555) 123-4567</span>
                </div>
                <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                  <span style={{
                  color: "oklch(0.704 0.04 256.788)",
                  flexShrink: 0,
                  width: "16px",
                  height: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg>
                  </span>
                  <span style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400"
                }}>hello@csndigital.com</span>
                </div>
                <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                  <span style={{
                  color: "oklch(0.704 0.04 256.788)",
                  flexShrink: 0,
                  width: "16px",
                  height: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
                  </span>
                  <span style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400"
                }}>Serving Local Businesses Nationwide</span>
                </div>
              </div>
              <div style={{
              marginTop: "24px",
              display: "flex",
              gap: "8px"
            }}>
                <button className="social-btn" aria-label="Facebook">
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 320 512" height="14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"></path></svg>
                </button>
                <button className="social-btn" aria-label="X Twitter">
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>
                </button>
                <button className="social-btn" aria-label="Instagram">
                  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="14" width="14" xmlns="http://www.w3.org/2000/svg" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                </button>
                <button className="social-btn" aria-label="LinkedIn">
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>
                </button>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-8 md:gap-0 flex-1 md:justify-between">
              <div style={{
              minWidth: "160px"
            }}>
                <p style={{
                color: "rgb(255, 255, 255)",
                fontFamily: '"DM Sans", sans-serif',
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "20px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                marginBottom: "16px"
              }}>
                  SERVICES
                </p>
                <ul style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px"
              }}>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Website Design</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Local SEO</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Google Business Profile</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Digital Marketing</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Website Maintenance</Link>
                  </li>
                </ul>
              </div>

              <div style={{
              minWidth: "160px"
            }}>
                <p style={{
                color: "rgb(255, 255, 255)",
                fontFamily: '"DM Sans", sans-serif',
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "20px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                marginBottom: "16px"
              }}>
                  COMPANY
                </p>
                <ul style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px"
              }}>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">About Us</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Portfolio</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Case Studies</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Testimonials</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Blog</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Our Process</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Industries We Serve</Link>
                  </li>
                </ul>
              </div>

              <div style={{
              minWidth: "160px"
            }}>
                <p style={{
                color: "rgb(255, 255, 255)",
                fontFamily: '"DM Sans", sans-serif',
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "20px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                marginBottom: "16px"
              }}>
                  RESOURCES
                </p>
                <ul style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px"
              }}>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Free Consultation</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Request a Quote</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Contact Us</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">FAQ</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Privacy Policy</Link>
                  </li>
                  <li style={{
                  color: "oklch(0.704 0.04 256.788)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  textAlign: "left"
                }}>
                    <Link to="#" className="footer-link">Terms of Service</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div style={{
        height: "1px",
        backgroundColor: "#1e2d40",
        width: "100%"
      }} />

        <div style={{
        paddingTop: "32px",
        paddingBottom: "32px"
      }}>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <p style={{
              color: "rgb(255, 255, 255)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: "28px",
              margin: "0 0 4px 0"
            }}>
                Ready to grow your business?
              </p>
              <p style={{
              color: "oklch(0.554 0.046 257.417)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              margin: "0"
            }}>
                Get a free, no-obligation consultation today.
              </p>
            </div>
            <Link to="#" className="cta-btn">
              Get My Free Consultation
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
            </Link>
          </div>
        </div>
      </div>

      <div style={{
      borderTop: "1px solid #1e2d40"
    }}>
        <div className="page-container">
          <div style={{
          paddingTop: "24px",
          paddingBottom: "24px"
        }} className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p style={{
            color: "oklch(0.704 0.04 256.788)",
            fontFamily: '"DM Sans", sans-serif',
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            margin: "0"
          }}>
              © 2026 CSN Digital. All rights reserved.
            </p>
            <div style={{
            display: "flex",
            gap: "24px"
          }}>
              <Link to="#" style={{
              color: "oklch(0.704 0.04 256.788)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              textDecoration: "none",
              transition: "color 0.15s ease"
            }} className="footer-link" onMouseEnter={e => e.currentTarget.style.color = "#ffffff"} onMouseLeave={e => e.currentTarget.style.color = "oklch(0.704 0.04 256.788)"}>
                Privacy Policy
              </Link>
              <Link to="#" style={{
              color: "oklch(0.704 0.04 256.788)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              textDecoration: "none",
              transition: "color 0.15s ease"
            }} className="footer-link" onMouseEnter={e => e.currentTarget.style.color = "#ffffff"} onMouseLeave={e => e.currentTarget.style.color = "oklch(0.704 0.04 256.788)"}>
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}